<template>
  <div class="faqDetail">
    <TopBack :handelBack="$parent.close"/>
    <div class="detailContainer">
      <div class="title">{{detail.label}}</div>
      <div class="part" v-for="(item, index) in detailList[detail.key]" :key="index">
        <div class="subTitle">{{item.subTitle}}</div>
        <div class="content" v-html="item.content"></div>
      </div>
      <div class="bottomLogo">
        <img :src="logo" alt="">
      </div>
    </div>
  </div>

</template>

<script>
import TopBack from '@/components/TopBack/index'
import logo from '@/assets/images/common/logo1.svg'

export default {
  name: 'faqDetail',
  props: ['detail'],
  data () {
    return {
      logo,
      detailList: this.$t('lang.faqDetailList')
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.detailList = this.$t('lang.faqDetailList')
    }
  },
  components: {
    TopBack
  }
}
</script>

<style lang="less" scoped>
  .faqDetail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #161616;
    .detailContainer {
      height: 100%;
      overflow: auto;
      margin-top: 22px;
      padding: 0 16px;
      .title {
        font-size: 24px;
        line-height: 28px;
        color: #F6D9AA;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .part {
        margin-bottom: 20px;
        .subTitle {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
          font-weight: bold;
          margin-bottom: 8px;
        }
        .content {
          font-size: 14px;
          line-height: 24px;
          color: #EFEFEF;
        }
      }
      .bottomLogo {
        text-align: right;
        img {
          width: 40px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FAQ/children/FAQdetail.vue